import {Injectable} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";

@Injectable()
export class ChosenCategoryService {

    private categorySelected: Subject<any> = new Subject<any>();
    private categoryDeSelected: Subject<any> = new Subject<any>();
    private categoryDeleted: Subject<any> = new Subject<any>();
    private categoriesLoaded: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

    private loadedCategories = [];

    selectedCategoryEvent = this.categorySelected.asObservable();
    deSelectedCategoryEvent = this.categoryDeSelected.asObservable();
    categoryDeletedEvent = this.categoryDeleted.asObservable();
    categoriesLoadedEvent = this.categoriesLoaded.asObservable();

    selected(category) {
        this.categorySelected.next(category);
        this.loadedCategories.push(category);
        this.categoriesLoaded.next(this.loadedCategories);
    }

    unSelected(category) {
        this.categoryDeSelected.next(category);
        this.loadedCategories = this.loadedCategories.filter(item => category.id != item.id);
        this.categoriesLoaded.next(this.loadedCategories);
    }

    deleted(category) {
        this.categoryDeleted.next(category);
        this.loadedCategories = this.loadedCategories.filter(item => category.id != item.id);
        this.categoriesLoaded.next(this.loadedCategories);
    }

    loaded(categories) {
        this.categoriesLoaded.next(categories);
        categories.forEach(category => {
            this.loadedCategories.push(category);
        })
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/business-category/chosen-category.service.ts